import React, { useState, useEffect, useRef, Component } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import ApiService from '../../services/apiService';
import { useNavigate } from 'react-router-dom';
import moment from 'moment/moment';
import { FaRegEye } from "react-icons/fa6";
import { IoAddSharp } from "react-icons/io5";
import Pagination from '../pagination/pagination';
import { GrEdit } from "react-icons/gr";
import { AiOutlinePrinter } from "react-icons/ai";
import { clearRows } from '../../../Redux/actions/rowActions';
import { useDispatch } from 'react-redux';
import { FaFileCircleExclamation } from "react-icons/fa6";
import { RiRefreshLine } from "react-icons/ri";
import { ClipLoader } from 'react-spinners';
import Select from 'react-select';

const ItemIssueGrid = () => {
    const REPORT_URL = process.env.REACT_APP_REPORTS_URL
    const [rowData, setRowData] = useState([]);
    const [loading, setLoading] = useState(true);
    let navigate = useNavigate();
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const [permissions, setPermissions] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [selectedtem, setSelectedItem] = useState(null);
    const [searchLoader, setLoader] = useState(false);
    const gridRef = useRef();
    const apiService = new ApiService();
    let dispatch = useDispatch()

    useEffect(() => {
        getItems();
        const storedPermissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
        const permissions = storedPermissions?.filter(acc => acc.formName === "Item Issue");
        setPermissions(permissions[0]);
    }, []);
    const [formData, setFormData] = useState({
        reqNo: "",
        remarks: "",
        status: [{ label: 'All', value: 'All' }],
    });
    const StatusFilter = [
        { value: '', label: 'All' },
        { value: '0', label: 'Pending' },
        { value: '1', label: 'Approved' },
        { value: '5', label: 'Hold' },
        { value: '2', label: 'Rejected' },
    ];
    const onGridReady = (params) => {
        gridRef.current = params.api;
        params.api.showLoadingOverlay();
    };
    const handlePrint = () => {
        if (selectedRow) {
            const token = localStorage.getItem("Token");
            const DB = localStorage.getItem("DataBase")
            if (!token) {
                alert("Auth token is missing! Unable to proceed.");
                return;
            }
            const popupWidth = 1000;
            const popupHeight = 600;
            const popupLeft = (window.screen.width - popupWidth) / 2;
            const popupTop = (window.screen.height - popupHeight) / 2;
            const popup = window.open(
                "",
                "ReportPopup",
                `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
            );

            if (popup) {
                const form = document.createElement("form");
                form.method = "POST";
                form.action =
                    REPORT_URL;
                form.target = "ReportPopup";

                const inputs = [
                    { name: "authToken", value: token },
                    { name: "_db", value: DB },
                    { name: "reportName", value: "Issue" },
                    { name: "voucherNo", value: selectedRow?.issueNo },
                ];

                inputs.forEach(({ name, value }) => {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
        }
    }
    const handleEye = (clickedRowData) => {
        dispatch(clearRows());
        if (clickedRowData.issueNo) {
            const updatedData = { ...clickedRowData, eye: !clickedRowData.eye?.active };
            navigate(`/Inventory/IssueItems/${updatedData.issueNo}`, { state: updatedData });
        } else {
            const updatedData = { ...selectedRow, eye: !selectedRow.eye?.active };
            navigate(`/Inventory/IssueItems/${updatedData.issueNo}`, { state: updatedData });
        }
    }
    const handleEdit = (clickedRowData) => {
        let eye = false
        dispatch(clearRows());

        if (clickedRowData?.issueNo) {
            const updatedData = { ...clickedRowData, eye: eye };
            if (updatedData?.status === 1) {
                const updatedData = { ...clickedRowData, eye: !clickedRowData.eye?.active };
                navigate(`/Inventory/IssueItems/${updatedData.issueNo}`, { state: updatedData });
            } else {
                navigate("/Inventory/IssueItems/Update", { state: clickedRowData });
            }
        } else {
            const updatedData = { ...selectedRow, eye: eye };
            if (updatedData?.status === 1) {
                const updatedData = { ...selectedRow, eye: !selectedRow.eye?.active };
                navigate(`/Inventory/IssueItems/${updatedData.issueNo}`, { state: updatedData });
            } else {
                navigate("/Inventory/IssueItems/Update", { state: selectedRow });
            }
        }
    }
    const getItems = async (newPageNo = pagination?.currentPage, clearedFormData) => {
        try {
            
            gridRef.current?.showLoadingOverlay();
            setLoader(true)
            const params = new URLSearchParams();
            params.append('PageNo', newPageNo || 1);
            params.append('PageSize', pageSize || 20);
            params.append('Mode', 0);
            params.append('IssueNo', clearedFormData?.reqNo === "" || null ? "" : formData?.reqNo || "");
            params.append('RequisitionNo', clearedFormData?.remarks === "" || null ? "" : formData?.remarks || "");
            params.append('Status', clearedFormData?.status?.value === "" || null ? "" : formData?.status?.value || "");
            const res = await apiService.getApiParamater('GET_ITEM_ISSUE', `?${params.toString()}`);
            setPagination(res.data.paginationData);
            setRowData(res.data.result || []);
            setLoading(false);
            setLoader(false)
            gridRef.current?.hideOverlay();
        } catch (error) {
            console.error('Error fetching items:', error);
            setLoading(false);
            setLoader(false)
            gridRef.current?.hideOverlay();
        }
    }
    const dateFormatter = (params) => {
        const date = moment(params.value);
        return date.format("DD-MMM-YYYY");
    }
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1;
    }
    const columnDefs = [
        { headerCheckboxSelection: true, checkboxSelection: true, headerCheckboxSelectionFilteredOnly: true, suppressMovable: true, width: 50 },
        { headerName: 'issue Note No', field: 'issueNo', width: 140, suppressMovable: true, },
        { headerName: 'Req No', field: 'requisitionNo', width: 140, suppressMovable: true, },
        {
            headerName: "Date", field: "issueDate",
            valueFormatter: dateFormatter,
            comparator: dateComparator, width: 160, suppressMovable: true,
        },
        { headerName: 'From Location', field: 'warehouse', width: 160, suppressMovable: true, },
        { headerName: 'To Location', field: 'divisionName', width: 160, suppressMovable: true, },
        { headerName: 'Department', field: 'costCenter1', width: 160, suppressMovable: true, },
        { headerName: 'Delivery Point', field: 'costCenter2', width: 160, suppressMovable: true, },
        { headerName: 'Property', field: 'costCenter3', width: 160, suppressMovable: true, },
        { headerName: 'Unit', field: 'remarks', width: 160, suppressMovable: true, },
        {
            headerName: 'Status', field: 'status',
            cellRenderer: function (params) {
                if (params.value === 0 || params.value === null) {
                    return (<button class="btn pend ">Pending</button>);
                }
                else if (params.value === 1 || params.value === null) {
                    return (<button class="btn aproved">Approved</button>);
                }
                else if (params.value === 5 || params.value === null) {
                    return (<button class="btn hold">Hold</button>);
                }
                else if (params.value === 2 || params.value === null) {
                    return (<button class="btn reject">Rejected</button>);
                }
                else if (params.value === 3 || params.value === null) {
                    return (<button class="btn aproved">Approved</button>);
                } else {
                    return params.value;
                }
            }, width: 140, suppressMovable: true,
        }
    ]
    const handlenew = () => {
        dispatch(clearRows());
        navigate('/Inventory/IssueItems/Create')
    }
    const onCellClicked = (event) => {
        if (event.colDef.field === 'issueNo') {
            const clickedRowData = event.data;
            handleEye(clickedRowData)
        }
    }
    const onSelectionChanged = async (event) => {
        const selectedRows = event.api.getSelectedRows();
        setSelectedRow(selectedRows.length === 1 ? selectedRows[0] : null);
        const params = new URLSearchParams();
        params.append('DocNo', selectedRows[0]?.issueNo);
        params.append('DocumentType', "Issue Item");
        try {
            const res = await apiService.getApiParamater('GET_EDITABLE_DOC', `?${params.toString()}`);
            const statuses = res?.data?.result?.map(item => item.status);
            const allAreZero = statuses.every(status => status === 0);
            const anyIsFive = statuses.some(status => status === 2);
            if (allAreZero || anyIsFive) {
                setSelectedItem(selectedRows.length === 1 ? selectedRows[0] : null);
            } else {
                console.warn("No valid status to set the item.");
                setSelectedItem(null);
            }
        } catch (error) {
            setSelectedItem(null)
            console.error("Error fetching document status:", error);
        }
    }
    const handleClearFilters = () => {
        const clearedFormData = {
            reqNo: "",
            remarks: "",
            status: [{ label: 'All', value: 'All' }],
        };
        setFormData(clearedFormData);
        getItems(1, clearedFormData);
    };
    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const handlelocChange = (selectedOption) => {
        setFormData({ ...formData, status: selectedOption });
    };
    return (
        <div className='p-4'>

            <div className='justify-content-between d-flex align-items-center'>
                <h4 className='mainInvHead'>
                    Issue Items List
                </h4>
                <div className='d-flex justify-content-end gap-1'>
                    <div
                        onClick={handleEye}
                        className={`mainbtnGry flex-end gap-2 ${!selectedRow ? 'disabled' : ''}`}
                        style={{ cursor: selectedRow ? 'pointer' : 'not-allowed' }}
                    >
                        <FaRegEye color='#fff' className='center mt-1' />
                        <div className='center'>View</div>
                    </div>
                    {/* {permissions?.canUpdate === true ? */}
                        <div
                            onClick={selectedtem && selectedtem?.status === 0 || selectedtem?.status === 2 ? handleEdit : null}
                            className={`mainbtnSecondary flex-end gap-2 ${!selectedtem || selectedtem?.status === 0 || selectedtem?.status === 2 ? '' : 'disabled'
                                }`}
                            style={{
                                cursor: selectedtem && selectedtem?.status === 0 || selectedtem?.status === 2 ? 'pointer' : 'not-allowed',
                            }}
                        >
                            <GrEdit color='#fff' className='center mt-1 ' />
                            <div className='center'>Edit</div>
                        </div> : ''
                    {/* } */}
                    <div
                        onClick={handlePrint}
                        className={`mainbtnRed flex-end gap-2 ${!selectedRow ? 'disabled' : ''}`}
                        style={{ cursor: selectedRow ? 'pointer' : 'not-allowed' }}
                    >
                        <AiOutlinePrinter color='#fff' className='center mt-1 ' />
                        <div className='center'>Print</div>
                    </div>
                    {permissions?.canAdd === true ?
                        <div className='col center'>
                            <button className='mainbtn ' type="submit" onClick={() => handlenew()}>
                                <IoAddSharp color='#fff' className='center mt-1' /> <div>Add</div>
                            </button>
                        </div>
                        : ''
                    }
                </div>
            </div>
            <div className='gridBg my-3' style={{ borderRadius: "16px 16px 16px 16px" }}>
                <div className='row d-flex justify-content-between'>
                    <div className='col-3 d-flex justify-content-between'>
                        <label htmlFor="PropertyGroup" className="form-label  pt-2 start">Issue No</label>
                        <input
                            type='text'
                            className="form-Input w-100"
                            value={formData.reqNo}
                            name="reqNo"
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className='col-3 d-flex justify-content-between'>
                        <label htmlFor="PropertyGroup" className="form-label  pt-2 start">Store Req No</label>
                        <input
                            type='text'
                            className="form-Input w-100"
                            value={formData.remarks}
                            name="remarks"
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className='col-3 d-flex justify-content-between'>
                        <label htmlFor="PropertyGroup" className="form-label  pt-2 start">Status</label>
                        <Select
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 2,
                                height: 25,
                                minHeight: 25
                            })}
                            className="w-100 p-0"
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                    color: state.isFocused ? '#000 ' : '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',
                                        color: '#000 ',
                                    },
                                }),
                            }}
                            value={formData?.status}
                            onChange={(selectedOption) => handlelocChange(selectedOption)}
                            options={StatusFilter}
                        />
                    </div>
                    <div className='col'>
                        {searchLoader === true ?
                            <button className='mainbtnGry w-100 ' type="submit"><ClipLoader color="#ffffff" size={25} /></button> :
                            <div onClick={() => getItems(1)} className='mainbtnGry flex-end gap-2'>
                                <FaFileCircleExclamation color='#fff' className='center mt-1 mx-2' />
                                <div className='center'>Search</div>
                            </div>
                        }
                    </div>
                    <div className='col'>
                        <div onClick={() => handleClearFilters()} className='mainbtnRed flex-end  gap-2'>
                            <RiRefreshLine color='#fff' className='center mt-1 mx-2' />
                            <div className='center'>Reset</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='brderbox mt-3'>
                <div className="ag-theme-quartz" style={{ height: 650 }}>
                    <AgGridReact
                        getRowStyle={(params) => {
                            if (params.node.rowIndex % 2 === 0) {
                                return { background: '#F0EDF5' };
                            } else {
                                return { background: '#fff' };
                            }
                        }}
                        rowData={rowData}
                        rowSelection={'single'}
                        columnDefs={columnDefs}
                        onGridReady={onGridReady}
                        loading={searchLoader}
                        enableFilter={true}
                        onCellClicked={onCellClicked}
                        onSelectionChanged={onSelectionChanged}
                    />
                </div>
            </div>
            <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
        </div>
    );
};

export default ItemIssueGrid;
